import { RatingSvgProps } from './types'

const Vnr = ({ className, width, height }: RatingSvgProps) => {
  return (
    <svg viewBox="0 0 144 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...{ className, width, height }}>
      <path
        d="M1.58439 18.2669C6.43438 26.3269 12.4744 33.7169 17.8444 41.5469C28.1844 55.6869 38.9744 71.5669 56.3044 77.4369C78.0544 85.1969 99.5944 71.0569 114.784 56.4669C124.684 47.0269 132.744 35.1369 139.624 23.1769C143.494 16.9369 145.514 8.48687 139.174 3.23685C135.354 -0.123151 129.584 -1.18315 125.154 1.70685C121.544 4.01685 119.334 7.90687 117.174 11.5169C108.244 26.8469 97.1944 41.3269 81.7044 50.1869C73.5844 54.7869 65.2044 56.2869 57.6344 49.8169C50.8244 44.1869 46.2344 37.6869 40.9244 30.4669C35.8344 23.4969 30.9144 16.4069 25.7844 9.45687C23.8044 6.82687 21.6244 4.15685 18.9144 2.31685C8.41438 -5.11315 -4.30561 6.73687 1.42439 17.9469L1.59439 18.2869L1.58439 18.2669Z"
        fill="#2F6654"
      />
    </svg>
  )
}

export default Vnr
